export const environment = {
  production: false,
  apiUrl: 'https://sbe-api-staging.schoolbell-e.com',
};
